import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Banner shown only to admin users when the last backup is >7 days old (or never). */
export default function BackupReminder() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user || user.role !== "admin") return;
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/admin/backup/status");
        if (!cancelled) setInfo(r.data);
      } catch { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, [user]);

  if (!user || user.role !== "admin") return null;
  if (!info || dismissed) return null;
  const days = info.days_since;
  const never = days === null;
  // Show only if >7 days or never
  if (!never && days < 7) return null;

  const message = never
    ? "Aún no has descargado ninguna copia de seguridad. Te recomiendo hacerlo ahora."
    : `Hace ${days} días que no descargas copia de seguridad. ¡Es buen momento!`;

  return (
    <div className="mx-auto mt-3 flex max-w-7xl items-center justify-between gap-3 rounded-lg border border-amber-300/70 bg-amber-50 px-4 py-2.5 text-sm text-amber-900"
         data-testid="backup-reminder">
      <span className="flex items-center gap-2">
        <span className="text-base">⚠️</span>
        <span>{message}</span>
      </span>
      <span className="flex items-center gap-2">
        <Link to="/admin/users" data-testid="backup-reminder-go"
              className="rounded-full bg-amber-700 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-white hover:bg-amber-800">
          Hacer copia
        </Link>
        <button onClick={() => setDismissed(true)} title="Recordar más tarde" data-testid="backup-reminder-dismiss"
                className="text-amber-700 hover:text-amber-900">✕</button>
      </span>
    </div>
  );
}
